import { useTranslation } from "react-i18next";
import { Button, Icon, Input } from "semantic-ui-react";

const InputComponents = ({
  inputProps,
  index,
  focusProps,
  dataProps,
  setDataProps,
  onFocus,
  placeholder,
  className,
}) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  return (
    <section
      className={`${
        inputProps?.needButton && "flex items-center gap-[10px] justify-between"
      }  mb-[15px]`}
    >
      <Input
        onFocus={onFocus}
        key={index}
        iconPosition={"right"}
        className={`${inputProps?.needButton ? "w-full" : "w-full"} shadow`}
      >
        <input
          disabled={inputProps?.disabled}
          type={inputProps?.type}
          value={dataProps?.[inputProps.name]}
          name={inputProps?.name}
          onChange={inputProps?.onChange}
          pattern={inputProps?.pattern}
          title={inputProps?.title}
          required={inputProps?.required}
          // !text-[#e2e8e3]
          className={`!text-base-light-dark dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark rounded-[5px] font-bold py-[15px] !active:border !active: !active:border-main-input-border ${className}`}
          placeholder={
            placeholder
              ? placeholder
              : `${i18n_common("pleaseInput")} ${inputProps?.label}`
          }
        />
        {focusProps[inputProps.name] && dataProps[inputProps.name] !== "" ? (
          <Icon
            link
            className={`text-dark-gray-text ${
              inputProps.needIcon && "!mr-[30px]"
            }`}
            name={`close`}
            onClick={() =>
              setDataProps({ ...dataProps, [inputProps.name]: "" })
            }
          />
        ) : null}

        {inputProps.needIcon && (
          <Icon
            link
            onClick={inputProps.function}
            className="text-dark-gray-text"
            name={inputProps.icon1}
          />
        )}
      </Input>
      {inputProps.needButton && (
        <Button
          disabled={inputProps.buttonProps?.disabled}
          onClick={inputProps.buttonProps?.onClick}
          className={`${inputProps.buttonProps?.className} !py-[10px] w-full`}
        >
          {inputProps.buttonText}
        </Button>
      )}
    </section>
  );
};

export default InputComponents;
